module.exports = __webpack_public_path__ + "img/Y_070_1p8c.6e2b81a8.png";